import { render, staticRenderFns } from "./officeInfos.vue?vue&type=template&id=2a5eb0c6"
import script from "./officeInfos.vue?vue&type=script&lang=js"
export * from "./officeInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports